<template>
    <div>

        <div>
            <div>
                <van-sticky>
                    <div style="padding: 10px 0px 0px 0px">
                        <van-icon name="arrow-left" size="20px" @click="onback"/>
                    </div>
                </van-sticky>
            </div>
            <div style="padding: 10px;">
                <Row>
                    <label>车牌号：{{maintain.vehicleInfo != null ? maintain.vehicleInfo.registrationNum :
                        maintain.tempVehicleInfo.registrationNum}}</label>
                </Row>
                <Row>
                    <label>车架号：{{maintain.vehicleInfo != null ? maintain.vehicleInfo.vin :
                        maintain.tempVehicleInfo.vin}}</label>
                </Row>
                <Row>
                    <label style="color: #fc0000;">备注：{{maintain.remark != null ? maintain.remark :
                        '无'}}</label>
                </Row>
            </div>
        </div>
        <!--  维修订单步骤  -->
        <van-tabs v-model="active">
            <van-tab title="历史记录">
                <!--  该车辆的历史维修记录  -->
                <div v-for="item in historymaintain">
                    <card v-if="item.id != maintainOrdersDetailId" style="border-color: #666666;margin-bottom: 5px;">

                        <div>
                            <p>故障：{{item.question}}</p>

                            <p>维修完成时间：{{item.maintainDatetime==null?'':new Date(item.maintainDatetime).Format('yyyy年MM月dd日')}}</p>
                        </div>
                        <div v-for="maintainDeviceRecord in item.maintainDeviceRecords">

                            <card>
                                <p>维修主机号：{{maintainDeviceRecord.terminalNum}}</p>
                                <p>维修设备：{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}</p>
                                <div v-if="maintainDeviceRecord.changeDevice" style="color: red">
                                    <p>换机：</p>
                                    <p>{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}(设备号：{{maintainDeviceRecord.positioningDeviceInfo.factoryTerminalNum}}) -> {{maintainDeviceRecord.newPositioningDeviceModel == null?'无':maintainDeviceRecord.newPositioningDeviceModel.name}}(设备号：{{maintainDeviceRecord.newFactoryTerminalNum}})</p>
                                </div>
                                <div v-if="maintainDeviceRecord.changeSim" style="color: red">
                                    <p>换卡：</p>
                                    <p>{{maintainDeviceRecord.terminalNum}} -> {{maintainDeviceRecord.newTerminalNum}}</p>
                                </div>
                                <div v-if="maintainDeviceRecord.removeDevice" style="color: red">
                                    <p>拆机：</p>
                                    <p>{{maintainDeviceRecord.terminalNum}} ：{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}</p>
                                </div>
                                <p>维修结果：{{maintainDeviceRecord.result}}</p>
                            </card>

                        </div>
                    </card>
                </div>
                <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                    下一步
                </Button>
            </van-tab>
            <van-tab title="当前记录">

                <div>
                    <card>
                        <div>
                            <label>故障：{{maintain.question}}</label>
                            <Button type="info" size="small" style="position:absolute;right: 20px;" @click="onMaintainOrderAddMaintainDeviceRecordModal(maintain)">添加记录</Button>
                        </div>
                        <p>预约维修时间：{{maintain.bookingDatetime==null?'':new Date(maintain.bookingDatetime).Format('yyyy年MM月dd日')}}</p>
                        <div v-for="maintainDeviceRecord in maintain.maintainDeviceRecords">
                            <card>
                                <p>维修主机号：{{maintainDeviceRecord.terminalNum}}</p>
                                <div>
                                    <label>维修设备：{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}</label>
                                    <!--                                <Button type="info" size="small" style="position:absolute;right: 20px;top: 20px;" @click="onMaintainOrderAddMaintainDeviceRecordResultModal(maintain)">维修结果</Button>-->
                                    <Button type="info" size="small" style="position:absolute;right: 20px;top: 10px;" @click="onMaintainOrderModifyMaintainDeviceRecordModal(maintainDeviceRecord)">修改</Button>
                                    <Button type="info" size="small" style="position:absolute;right: 20px;" @click="onMaintainOrderRemoveMaintainDeviceRecordModal(maintainDeviceRecord)">删除</Button>
                                </div>
                                <!--                                <p>维修结果：{{maintainDeviceRecord.result}}</p>-->
                                <div v-if="maintainDeviceRecord.changeDevice" style="color: red">
                                    <p>换机：</p>
                                    <p>{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}(设备号：{{maintainDeviceRecord.positioningDeviceInfo.factoryTerminalNum}}) -> {{maintainDeviceRecord.newPositioningDeviceModel == null?'无':maintainDeviceRecord.newPositioningDeviceModel.name}}(设备号：{{maintainDeviceRecord.newFactoryTerminalNum}})</p>
                                </div>
                                <div v-if="maintainDeviceRecord.changeSim" style="color: red">
                                    <p>换卡：</p>
                                    <p>{{maintainDeviceRecord.terminalNum}} -> {{maintainDeviceRecord.newTerminalNum}}</p>
                                </div>
                                <div v-if="maintainDeviceRecord.removeDevice" style="color: red">
                                    <p>拆机：</p>
                                    <p>{{maintainDeviceRecord.terminalNum}} ：{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}</p>
                                </div>


                            </card>

                        </div>
                    </card>

                    <!--   添加维修记录     -->
                    <maintain-order-add-maintain-device-record-modal v-model="maintainOrderAddMaintainDeviceRecordModal"
                                                                     :initValue="maintainOrderAddMaintainDeviceRecordId"
                                                                     @on-success="refresh"></maintain-order-add-maintain-device-record-modal>
                    <!--   修改维修记录     -->
                    <maintain-order-modify-maintain-device-record-modal v-model="maintainOrderModifyMaintainDeviceRecordModal"
                                                                        :initValue="maintainOrderModifyMaintainDeviceRecordId"
                                                                        @on-success="refresh"></maintain-order-modify-maintain-device-record-modal>

                </div>
                <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                    上一步
                </Button>
                <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                    下一步
                </Button>
            </van-tab>
            <van-tab title="图片">

                <div v-if="maintain.maintainDeviceRecords">
                <div v-if="maintain.maintainDeviceRecords.length > 1">
                <Select v-model="MaintainPicture.id" @on-change="onChangeMaintainDeviceRecords">
                    <Option v-for="item in maintain.maintainDeviceRecords" :value="item.id" :key="item.id">{{item.positioningDeviceInfo.terminalNum+'('+ (item.positioningDeviceInfo.positioningDeviceModel == null ? '无' : item.positioningDeviceInfo.positioningDeviceModel.name) +')'}}</Option>
                </Select>
                </div>
                </div>

                <div style="margin-top: 10px;margin-left: 20px;text-align: center">
                    <div style="padding-bottom: 10px;">
                    <label>维修前</label>
                    </div>
                    <div>
                    <row>
                        <!--            <van-uploader disabled multiple v-model="beforePics" name="1" :after-read="afterRead" :before-delete="deletePic">-->
                        <van-uploader multiple v-model="beforePics" name="1" :after-read="afterRead" :before-delete="deletePic">
                            <div></div>
                        </van-uploader>
                    </row>
                    </div>
                    <div>
                        <Button type="info" style="margin-right: 5px;" @click="uploadbeforePics(1)">拍摄维修前图片</Button>
<!--                        <Button type="info" @click="refresh">刷新</Button>-->
                    </div>
                </div>

<!--                <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">-->
<!--                    上一步-->
<!--                </Button>-->
<!--                <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">-->
<!--                    下一步-->
<!--                </Button>-->

                <van-divider/>
<!--            </van-tab>-->
<!--            <van-tab title="维修图片">-->

                <div style="margin-top: 10px;margin-left: 20px;text-align: center">
                    <div style="padding-bottom: 10px;">
                        <label>维修后</label>
                    </div>
                    <div>
                    <row>
                        <!--            <van-uploader disabled multiple v-model="afterPics" name="2" :after-read="afterRead" :before-delete="deletePic">-->
                        <van-uploader multiple v-model="afterPics" name="2" :after-read="afterRead" :before-delete="deletePic">
                            <div></div>
                        </van-uploader>
                    </row>
                    </div>
                    <div>
                        <Button type="info" style="margin-right: 5px;" @click="uploadbeforePics(2)">拍摄维修后图片</Button>
                        <!--                        <Button type="info" @click="refresh">刷新</Button>-->
                    </div>
                <van-overlay :show="showOverlay" @click="showOverlay = false">
                    <!--            <van-loading size="90" style="padding-top: 200px" color="#1989fa;"/>-->
                    <van-circle
                            v-model:current-rate="currentRate"
                            :rate="rate"
                            :speed="200"
                            :stroke-width="120"
                            style="padding-top: 200%"
                    >

                    </van-circle>
                </van-overlay>
                </div>
                <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                    上一步
                </Button>
                <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                    下一步
                </Button>
            </van-tab>
            <van-tab title="设备状态">

                <jt808-devices-for-terminalnum-modal v-model="jt808DevicesForTerminalnumModal"
                                                     :initValue="jt808DevicesForTerminalnumId"></jt808-devices-for-terminalnum-modal>

                <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                    上一步
                </Button>
                <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onNextPage(active)">
                    下一步
                </Button>
            </van-tab>
            <van-tab title="确认">

                <div>
                    <card>
                        <div>
                            <label>故障：{{maintain.question}}</label>
                            <!--                            <Button type="info" size="small" style="position:absolute;right: 20px;" @click="onMaintainOrderAddMaintainDeviceRecordModal(maintain)">添加记录</Button>-->
                        </div>
                        <p>预约维修时间：{{maintain.bookingDatetime==null?'':new Date(maintain.bookingDatetime).Format('yyyy年MM月dd日')}}</p>
                        <div v-for="maintainDeviceRecord in maintain.maintainDeviceRecords">
                            <card>
                                <p>维修主机号：{{maintainDeviceRecord.terminalNum}}</p>
                                <div>
                                    <label>维修设备：{{maintainDeviceRecord.positioningDeviceInfo.positioningDeviceModel.name}}</label>
                                    <Button type="info" size="small" style="position:absolute;right: 20px;top: 20px;" @click="onMaintainOrderAddMaintainDeviceRecordResultModal(maintainDeviceRecord)">维修结果</Button>
                                    <!--                                    <Button type="info" size="small" style="position:absolute;right: 20px;top: 10px;" @click="onMaintainOrderModifyMaintainDeviceRecordModal(maintainDeviceRecord)">修改</Button>-->
                                    <!--                                    <Button type="info" size="small" style="position:absolute;right: 20px;" @click="onMaintainOrderRemoveMaintainDeviceRecordModal(maintainDeviceRecord)">删除</Button>-->
                                </div>
                                <p>维修结果：{{maintainDeviceRecord.result}}</p>

                            </card>

                        </div>
                    </card>
                </div>

                <maintain-order-add-maintain-device-record-result-modal v-model="maintainOrderAddMaintainDeviceRecordResultModal"
                                                                        :initValue="maintainOrderAddMaintainDeviceRecordResultId"
                                                                        @on-success="refresh"></maintain-order-add-maintain-device-record-result-modal>


                <Button style="position: fixed;right: 90px;bottom: 10px;" type="info" @click="onLastPage(active)">
                    上一步
                </Button>
                <Button style="position: fixed;right: 10px;bottom: 10px;" type="info" @click="onSueeess(active)" :disabled="SueeessDisabled">
                    确认
                </Button>

                <van-overlay :show="showSueeessOverlay" @click="showSueeessOverlay = false">
                    <van-loading vertical size="90" style="padding-top: 200px" type="spinner" color="#2b85e4" text-color="#2b85e4">
                    提交中...
                    </van-loading>
                </van-overlay>

            </van-tab>
        </van-tabs>

    </div>
</template>

<script>
    const wx = require('weixin-js-sdk')
    import axios from 'axios'

    import Vue from 'vue'
    import store from '@/store'
    import {genQueryParam, genSortParam} from '@/libs/queryparamhelper'
    import MaintainOrderAddMaintainDeviceRecordModal
        from '@/views/om/installer-maintain-order/components/maintain-order-add-maintain-device-record-modal'
    import MaintainOrderModifyMaintainDeviceRecordModal
        from '@/views/om/installer-maintain-order/components/maintain-order-modify-maintain-device-record-modal'
    import MaintainOrderAddMaintainDeviceRecordResultModal
        from '@/views/om/installer-maintain-order/components/maintain-order-add-maintain-device-record-result-modal'

    import Jt808DevicesForTerminalnumModal from '@/views/ddm/components/jt808-devices-for-terminalnum-modal'

    import {
        Cell,
        CellGroup,
        Field,
        Row,
        Col,
        Button,
        Dialog,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        Picker,
        Popup,
        Divider,
        Collapse,
        CollapseItem,
        DatetimePicker,
        Tag,
        DropdownMenu,
        DropdownItem,
        Sticky,
        Icon,
        Search,
        PullRefresh,
        List,
        Loading,
        Toast,
        Uploader,
        Overlay,
        Tab,
        Tabs,
        Circle,
    } from 'vant'

    Vue.use(Cell).use(CellGroup).use(Field).use(Row).use(Col).use(Button).use(Dialog).use(Radio).use(Tag).use(DropdownMenu).use(Circle)
        .use(RadioGroup).use(Checkbox).use(CheckboxGroup).use(Picker).use(Popup).use(Divider).use(Collapse).use(CollapseItem).use(Overlay)
        .use(DatetimePicker).use(Icon).use(DropdownItem).use(Sticky).use(Search).use(PullRefresh).use(List).use(Loading).use(Toast).use(Uploader).use(Tab).use(Tabs);

    export default {
        name: "installer-maintain-order-confirm",
        components: {
            MaintainOrderAddMaintainDeviceRecordModal,
            MaintainOrderModifyMaintainDeviceRecordModal,
            MaintainOrderAddMaintainDeviceRecordResultModal,
            Jt808DevicesForTerminalnumModal,
        },
        data() {
            return {
                showOverlay: false,
                showSueeessOverlay: false,
                SueeessDisabled: false,
                currentRate: 0,
                rate: 0,

                maintain: {
                    businessUserId: null,
                    businessUser: null,
                    maintainerId: null,
                    maintainer: null,
                    vehicleInfoId: null,
                    vehicleInfo: {
                        customName: null,
                        registrationNum: null,
                        registrationColor: null,
                        vin: null,
                        bodyColor: null,
                        vehicleType: {
                            id: null,
                            name: null
                        },
                        vehicleBrand: {
                            id: null,
                            name: null
                        },
                        engineNum: null,
                        vehicleLicenseNum: null,
                        unladenMass: null,
                        approvedLoad: null,
                        vehicleOwnerInfoId: null,
                        servicePassword: null,
                        vehicleLicenseDistributeDatetime: null,
                        vehicleLicenseReigsterDatetime: null,
                        remark: null,
                        certificateNum: null,
                        certificateDistributeDatetime: null,
                        vehicleModel: {
                            id: null,
                            name: null
                        },
                        chassisModel: null,
                        chassisId: null,
                        chassisCertificateNum: null,
                        engineModel: null,
                        energyType: null,
                        displacement: null,
                        power: null,
                        energyUsage: null,
                        emissionStandard: null,
                        manufacturer: null,
                        outlineSizeLong: null,
                        outlineSizeWidth: null,
                        outlineSizeHeight: null,
                        boxSizeLong: null,
                        boxSizeWidth: null,
                        boxSizeHeight: null,
                        springPieceCount: null,
                        tyreCount: null,
                        tyreSpec: null,
                        wheelSpanFront: null,
                        wheelSpanBack: null,
                        wheelBase: null,
                        axisLoad: null,
                        axisCount: null,
                        turnType: null,
                        totalMass: null,
                        approvedLoadCoefficient: null,
                        towMax: null,
                        saddleMax: null,
                        cabPeopleCount: null,
                        mannedCount: null,
                        speedMax: null,
                        productionDatetime: null,
                        certificateRemark: null,
                        vehicleLicensePictureId: null,
                        certificatePictureId: null,
                        vehicleSrcLicensePicture1Id: null,
                        vehicleSrcLicensePicture2Id: null,
                        vehicleBodyPictureId: null,
                        vehicleUse: null,
                        attention: false,
                        mliftainsuranceChannelId: null,
                        mliftainsurancechannelDatetime: null,
                        tiinsuranceChannelId: null,
                        tiinsurancechannelDatetime: null,
                        insured: null,
                    },
                    updateDatetime: null,
                    bookingDatetime: null,
                    bookingPlace: null,
                    actualDatetime: null,
                    actualPlace: null,
                    maintainDatetime: null,
                    question: null,
                    result: null,
                    remark: null,
                    maintainDeviceRecords: null,
                    maintainType: 0,
                    positioningDeviceInfos:null,
                    urgent:'否',
                    receptDatetime:'否',
                    stepId:null,
                    step:{
                        orderId:null,
                        state:null,
                        lastState:null,
                        userId:null,
                        user:null,
                        result:null,
                    },
                },//订单
                maintainOrdersDetailId: null,//订单ID
                active: null,//流程页下标

                historymaintain: [],//历史维修记录

                // 增加设备维修记录
                maintainOrderAddMaintainDeviceRecordModal: false,
                maintainOrderAddMaintainDeviceRecordId: null,

                // 修改设备维修记录
                maintainOrderModifyMaintainDeviceRecordModal: false,
                maintainOrderModifyMaintainDeviceRecordId: null,

                maintainOrderAddMaintainDeviceRecordResultModal:false,
                maintainOrderAddMaintainDeviceRecordResultId:false,


                MaintainPicture:{
                    id:0,
                    picKey:null,
                    picType:null,
                    srcWidth:null,
                    srcHeight:null,
                },

                /**
                 * jt808,实时状态
                 */
                jt808DevicesForTerminalnumModal: false,
                jt808DevicesForTerminalnumId: [],

                afterPics: [],
                beforePics: [],
            }
        },
        methods: {
// <!-- icon返回路劲 -->
            onback() {
                this.$router.push({
                    name: 'installermaintainorder'
                })
            },
            /**
             * 流程上一步
             */
            onLastPage(page) {
                console.log(page)
                this.active = page - 1;
            },
            /**
             * 流程下一步
             */
            onNextPage(page) {
                console.log(page)
                this.active = page + 1;
            },
            /**
             * 选择维修记录
             */
            onChangeMaintainDeviceRecords(){
                this.loadingPic()
            },
            /**
             * 维修确认
             */
            onSueeess() {

                this.showSueeessOverlay = true
                this.SueeessDisabled = true

                //确认订单
                if (this.maintain.step != null){
                    this.maintain.step.state = 2
                }
                store.dispatch('MaintainOrderServ_ConfirmMaintained', {
                    params: this.maintain
                }).then(() => {
                    this.$Message.success('确认维修完成')
                    this.showSueeessOverlay = false
                    this.SueeessDisabled = false
                    this.orderDetil()
                }).catch(err => {
                    this.$Message.error(err)
                })
            },
            /**
             * 增加维修记录
             */
            onMaintainOrderAddMaintainDeviceRecordModal(e){
                console.log(e)
                this.maintainOrderAddMaintainDeviceRecordModal = true
                this.maintainOrderAddMaintainDeviceRecordId = e.id
            },

            /**
             * 修改维修订单维修记录
             */
            onMaintainOrderModifyMaintainDeviceRecordModal(e){
                this.maintainOrderModifyMaintainDeviceRecordModal = true
                this.maintainOrderModifyMaintainDeviceRecordId = e
            },
            /**
             * 删除维修记录
             */
            onMaintainOrderRemoveMaintainDeviceRecordModal(e){
                console.log(e)
                this.$Modal.confirm({
                    title: '提示',
                    content: '<p>确认删除</p>',
                    onOk: () => {
                        store.dispatch('MaintainOrderServ_RemoveMaintainDeviceRecord', {
                            params: {
                                maintainDeviceRecordId: e.id
                            },
                            urlparams: null
                        }).then(res => {
                            console.log(res)
                            this.refresh()

                        }).catch(err => {
                            console.log(err)
                            this.$Message.error(err)
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            /**
             * 增加维修结果
             */
            onMaintainOrderAddMaintainDeviceRecordResultModal(e){
                this.maintainOrderAddMaintainDeviceRecordResultModal = true
                this.maintainOrderAddMaintainDeviceRecordResultId = e
            },

            updateTable() {
                store.dispatch('MaintainOrderServ_GetPage', {
                    params: null,
                    urlparams: {
                        q: genQueryParam('vehicleInfoId', 'EQ', this.maintain.vehicleInfoId)
                    }
                }).then(res => {
                    console.log(res)
                    if (store.getters.get_MaintainOrder_GetPageResult) {
                        this.historymaintain = store.getters.get_MaintainOrder_GetPageResult.content
                    }
                }).catch(err => {
                    console.log(err)
                })
            },
            refresh(){
                this.afterPics = []
                this.beforePics = []
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {
                        id: this.maintainOrdersDetailId
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.maintain = res.data
                    this.updateTable()
                    if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords != null && store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length > 0) {
                        // store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                        // this.maintainpeList.push({
                        //     text: item.terminalNum.toString(), value: item.id
                        // })
                        // })
                        if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length == 1) {
                            this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
                        }
                    }
                    this.loadingPic()


                    /**
                     * 按设备信息查询jt808状态
                     */
                    if (res.data.maintainDeviceRecords && res.data.maintainDeviceRecords.length > 0) {
                        this.jt808DevicesForTerminalnumId = []
                        res.data.maintainDeviceRecords.forEach(item => {
                            if (item.changeSim) {
                                store.dispatch('PositioningDeviceInfoServ_SearchByName',{
                                    params:{
                                        name:item.newTerminalNum
                                    },
                                    urlparams:null,
                                }).then(res => {
                                    this.jt808DevicesForTerminalnumId.push(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0])
                                }).catch(err => {
                                    console.log(err)
                                })
                            }else {
                                store.dispatch('PositioningDeviceInfoServ_SearchByName',{
                                    params:{
                                        name:item.terminalNum
                                    },
                                    urlparams:null,
                                }).then(res => {
                                    this.jt808DevicesForTerminalnumId.push(store.getters.get_PositioningDeviceInfo_SearchByNameResult[0])
                                }).catch(err => {
                                    console.log(err)
                                })
                            }
                        })
                    }
                }).catch((err) => {
                    console.log(err)
                })
            },

            /**
             * 图片部分
             */
            deletePic(file, e) {
                // console.log(e)
                // console.log(file)
                this.$Modal.confirm({
                    title: '确认删除',
                    content: '<p>确认删除</p>',
                    onOk: () => {
                        store.dispatch('MaintainOrderServ_RemoveMaintainPicture', {
                            params: {maintainPictureId: file.id}
                        }).then(() => {
                            this.$Message.success('删除成功')
                            // this.loadingPic()
                            this.refresh()
                            this.$emit('on-success')
                        }).catch(err => {
                            this.$Message.error(err)
                            this.$emit('on-fail')
                        })
                    },
                    onCancel: () => {

                    }
                })
            },
            uploadbeforePics(e) {
                console.log(e)
                var appid = 'wx35df9038a4f73847'
                var noncestr = 'maintainOrders-UploaderImage-vant' + Date.parse(new Date()) / 1000
                var timestamp = Date.parse(new Date()) / 1000
                // let url = location.href.split('#')[0]
                var u = navigator.userAgent;
                var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
                var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
                let url = ''
                if (isAndroid) {
                    url = location.href
                }
                Vue.prototype.href = window.location.href
                if (isIOS) {
                    url = window.location.href.split('#')[0]  //hash后面的部分如果带上ios中config会不对
                }
                store.dispatch('MediaPlatformServ_GetSignature', {
                    urlparams: {
                        noncestr: noncestr,
                        timestamp: timestamp,
                        url: url,
                    }
                }).then(res => {
                    console.log(res)
                    // alert(res.data)
                    wx.config({
                        debug: false,
                        appId: appid,
                        timestamp: timestamp,
                        nonceStr: noncestr,
                        signature: res.data,
                        jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareWeibo', 'onMenuShareQZone',
                            'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getLocalImgData', 'checkJsApi'],
                        success: function (res) {
                            console.log(res)
                        },
                        fail: function (err) {
                            console.log(err)
                        }
                    });
                }).catch(err => {
                    console.log(err)
                })

                let that = this
                wx.ready(function () {
                    // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
                    // if (e == 2){

                        wx.chooseImage({
                            count: 9, // 默认9
                            sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                            sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                            isShowProcess: 1,
                            success: function (res) {
                                // console.log(res)
                                // console.log(res.localIds.length)
                                var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                                for (let i = 0; i <= res.localIds.length - 1; i++) {
                                    console.log(i)
                                    setTimeout(function timer() {
                                        //调用wx.getLocalImgData 获取base64 及转换成二进制 上传到七牛 绑定key到数据库
                                        that.uploadbefore(res.localIds[i], e, res.localIds.length, i);
                                        // that.loadingPic();
                                        // that.reload();
                                    }, i * 1000, i);
                                }
                            },
                            fail: function (err) {
                                console.log(err)
                            }
                        });

                    // } else {
                    //
                    //     wx.chooseImage({
                    //         count: 9, // 默认9
                    //         sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
                    //         sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
                    //         isShowProcess: 1,
                    //         success: function (res) {
                    //             // console.log(res)
                    //             // console.log(res.localIds.length)
                    //             var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                    //             for (let i = 0; i <= res.localIds.length - 1; i++) {
                    //                 console.log(i)
                    //                 setTimeout(function timer() {
                    //                     //调用wx.getLocalImgData 获取base64 及转换成二进制 上传到七牛 绑定key到数据库
                    //                     that.uploadbefore(res.localIds[i], e, res.localIds.length, i);
                    //                     // that.loadingPic();
                    //                     // that.reload();
                    //                 }, i * 1000, i);
                    //             }
                    //         },
                    //         fail: function (err) {
                    //             console.log(err)
                    //         }
                    //     });
                    //
                    // }
                });
                wx.error(function (res) {
                    // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
                    console.log(res)
                });
            },
            uploadbefore(localIds,e, length, i) {
                this.showOverlay = true
                let that = this
                wx.getLocalImgData({
                    localId: localIds,
                    success:  function (res) {
                        console.log('预览图片成功')
                        const localData = res.localData;
                        let imageBase64 = '';
                        console.log('转换成base64')
                        if (localData.indexOf('data:image') == 0) {
                            //苹果的直接赋值，默认生成'data:image/jpeg;base64,'的头部拼接
                            imageBase64 = localData;
                            console.log(imageBase64)
                        } else {
                            //此处是安卓中的唯一得坑！在拼接前需要对localData进行换行符的全局替换
                            //此时一个正常的base64图片路径就完美生成赋值到img的src中了
                            imageBase64 = 'data:image/jpeg;base64,' + localData.replace(/\n/g, '');
                            console.log(imageBase64)
                        }
                        console.log('base64转换成二进制')
                        let dataurltoblob = dataURLtoBlob(imageBase64)
                        console.log(dataurltoblob)

                        //获取七牛上传凭证
                        store.dispatch('PictureServ_GetQiniuUploadToken', {
                            params: {
                                head: 'MAINTAINORDER'
                            },
                            urlparams: null
                        }).then((res) => {
                            console.log(res)
                            let uploadToken = store.getters.get_Picture_GetQiniuUploadTokenResult.uploadToken
                            let photoKey = store.getters.get_Picture_GetQiniuUploadTokenResult.photoKey
                            handleAvatar(dataurltoblob, uploadToken, photoKey, e, length, i)
                        }).catch((err) => {
                            console.log(err)
                            this.errorlog('七牛错误' + err)
                        })

                        /**
                         * base64转为可post的二进制数据
                         */
                        function dataURLtoBlob(dataurl) {
                            let arr = dataurl.split(',');
                            let mime = arr[0].match(/:(.*?);/)[1];
                            let bstr = atob(arr[1]);
                            let n = bstr.length;
                            let u8arr = new Uint8Array(n);
                            while (n--) {
                                u8arr[n] = bstr.charCodeAt(n);
                            }
                            return new Blob([u8arr], {
                                type: mime
                            });
                        }

                        /**
                         * ajax上传图片
                         */
                        function handleAvatar(imageBase64, uploadToken, photoKey,e, length, i) {
                            console.log(imageBase64)
                            console.log(uploadToken)
                            console.log(photoKey)
                            var param = new FormData();
                            // param.append('headPic', imageBase64);
                            param.append('file', imageBase64);
                            param.append('chunk', '0');//断点传输
                            param.append('chunks', '1');
                            param.append('token', uploadToken)
                            param.append('key', photoKey);
                            let config = {
                                // headers:{'X-Requested-with':'XMLHttpRequest'},
                                // headers:{'Content-Type':'application/json'},
                                headers: {'Content-Type': 'multipart/form-data'},
                                // headers:{"Content-Type": "application/x-www-form-urlencoded;charset=utf-8",}  // 这里是跨域的写法
                                withCredentials: false
                            };

                            let MaintainPicture = {
                                id: null,
                                picKey: null,
                                picType: null,
                                srcWidth: null,
                                srcHeight: null,
                                upload_token: null,
                                picKey: null,
                            }
                            MaintainPicture.id = that.MaintainPicture.id
                            MaintainPicture.picType = e.toString()
                            MaintainPicture.srcWidth = imageBase64.srcWidth
                            MaintainPicture.srcHeight = imageBase64.srcHeight
                            MaintainPicture.upload_token = uploadToken
                            MaintainPicture.picKey = photoKey

                            axios.post('https://upload-z2.qiniup.com', param, config)
                                .then(response => {
                                    console.log(response);
                                    console.log(response.data);
                                    // this.addPictureRecord.picKey = this.MaintainPicture.picKey

                                    // console.log(this.addPictureRecord)
                                    //  未完成的订单
                                    //安装订单更换图片
                                    store.dispatch('MaintainOrderServ_UploadMaintainPicture', {
                                        params:
                                        MaintainPicture
                                        ,
                                        urlparams: null
                                    }).then((res) => {
                                        console.log(res)
                                        // Toast.success('添加图片成功')
                                        that.schedule(length, i)
                                        // that.loadingPic()
                                        // that.refresh()
                                        /**
                                         * 异步调用导致列表长度不对，无法正常点击table打开图片
                                         */
                                        // this.loadPhotoRecords(this.maintainOrderid)
                                    }).catch(err => {
                                        Toast(err)
                                        console.log(err)
                                    });
                                }).catch(err1 => {

                                Toast(err1)
                                // this.loadingStatus = false
                            })


                        };
                    },
                    fail: function (err) {
                        console.log(err)
                    },
                    complete: function (res) {
                        console.log(res)
                    }
                });
            },
            // 图片上传进度
            schedule(length, i) {
                this.afterPics = []
                this.beforePics = []
                length = length - 1
                this.rate = ((i+1)/length)*100
                if (length === i) {
                    this.showOverlay = false
                    this.loadingPic()
                }
            },
            loadingPic() {
                this.afterPics = []
                this.beforePics = []
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {id: this.maintainOrdersDetailId},
                    urlparams: null
                }).then(() => {
                    // console.log(store.getters.get_MaintainOrder_GetDetailResult)
                    if (store.getters.get_MaintainOrder_GetDetailResult) {
                        if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords != null && store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length > 0) {
                                store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                                    if (this.MaintainPicture.id == item.id) {
                                        item.afterPics.forEach(afterPicsItem => {
                                            this.afterPics.push({
                                                id: afterPicsItem.id,
                                                url: 'https://pic.jianchengjt.com/' + afterPicsItem.picKey + '?imageView2',
                                                isImage: true
                                            })
                                        })
                                        item.beforePics.forEach(beforePicsItem => {
                                            this.beforePics.push({
                                                id: beforePicsItem.id,
                                                url: 'https://pic.jianchengjt.com/' + beforePicsItem.picKey + '?imageView2',
                                                isImage: true
                                            })
                                        })
                                    }
                                })
                            }
                    }
                }).catch(err => {
                    this.$Message.error(err)
                })
            },

            orderDetil(){
                /**
                 * 查询订单信息
                 */
                store.dispatch('MaintainOrderServ_GetDetail', {
                    params: {
                        id: this.maintainOrdersDetailId
                    },
                    urlparams: null
                }).then((res) => {
                    console.log(res)
                    this.maintain = res.data
                    this.updateTable()

                    if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords != null && store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length > 0) {
                        // store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                        // this.maintainpeList.push({
                        //     text: item.terminalNum.toString(), value: item.id
                        // })
                        // })
                        if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length == 1) {
                            this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
                        }
                        store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                            this.jt808DevicesForTerminalnumId.push(item.positioningDeviceInfo)
                        })
                        this.loadingPic()
                    }

                }).catch((err) => {
                    console.log(err)
                })
            }
        },
        mounted() {
            // console.log(this.$route.query.maintainOrdersDetailid)
            if (this.$route.query.code != null) {
                this.getCode()
                this.maintainOrdersDetailId = this.$route.query.maintainOrdersDetailid
            } else {
                this.maintainOrdersDetailId = this.$route.query.maintainOrdersDetailid
            }
            if (this.maintainOrdersDetailId) {
                /**
                 * 查询订单信息
                 */
                // store.dispatch('MaintainOrderServ_GetDetail', {
                //     params: {
                //         id: this.maintainOrdersDetailId
                //     },
                //     urlparams: null
                // }).then((res) => {
                //     console.log(res)
                //     this.maintain = res.data
                //     this.updateTable()
                //
                //     if (store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords != null && store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.length > 0) {
                //         // store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords.forEach(item => {
                //         // this.maintainpeList.push({
                //         //     text: item.terminalNum.toString(), value: item.id
                //         // })
                //         // })
                //         this.MaintainPicture.id = store.getters.get_MaintainOrder_GetDetailResult.maintainDeviceRecords[0].id
                //         this.loadingPic()
                //     }
                //
                // }).catch((err) => {
                //     console.log(err)
                // })
                this.orderDetil()
            }
        }
    }
</script>

<style scoped>

</style>
